import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import useApi from "../api";
import { CustomError } from "../errors";
import { SearchPermissionResponse } from "./types";

export const usePermissionsApi = () => {
  const api = useApi();

  const baseurl = "/permissions";

  const usePermissions = useCallback(() => {
    const result = useQuery<SearchPermissionResponse, CustomError>({
      queryKey: [baseurl],
      queryFn: ({ signal }) => api.get<SearchPermissionResponse>({ url: baseurl, signal }),
    });
    return { ...result, error: result.error ?? undefined };
  }, [api]);

  return { usePermissions };
};
